<template>
  <button
    :id="field + '-calendar-scroll-field'"
    role="tab"
    class="calendar-scroll-header-date-input"
    :class="[{ selected: isSelected }]"
    :aria-selected="isSelected"
    :tabindex="isSelected ? '0' : '-1'"
    :aria-label="ariaLabel"
    @click="selectInput"
    @keyup.space.prevent="selectInput"
    @focus="bindKeyboardEvents"
    @blur="unbindKeyboardEvents"
  >
    <span class="calendar-scroll-header-date-input-label">
      {{ tc(`booking.${label}`) }}
    </span>
    <div class="calendar-scroll-header-date-input-field">
      <span class="calendar-icon-wrapper">
        <i
          class="icon-chevron-left"
          aria-hidden="true"
          @click="removeOneDay"
        />
      </span>
      <span class="calendar-scroll-header-date-input-field-value">{{ fieldFormat }}</span>
      <span class="calendar-icon-wrapper">
        <i
          class="icon-chevron-right"
          aria-hidden="true"
          @click="addOneDay"
        />
      </span>
    </div>
  </button>
</template>

<script>
  import moment from 'moment'
  import { mapGetters, mapState } from 'vuex'
  import { KEY_CODE_MAP } from '@utils/keyboard-helpers'

  export default {
    name: 'CalendarDateInput',
    inject: ['updateLocalQuery', 'localQuery'],
    props: {
      field: {
        type: String,
        required: true
      },
      fields: {
        type: Array,
        required: true
      },
      label: {
        type: String,
        required: true
      },
      inputSelected: {
        type: String,
        required: true
      },
    },
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapState('global', ['lang']),
      isSelected() {
        return this.inputSelected === this.field
      },
      displayFormat() {
        return this.lang === 'ar-ae' ? 'MMM D ddd' : 'ddd[,] MMM[.] D'
      },
      updateFormat() {
        return 'YYYY-MM-DD'
      },
      fieldDate() {
        return this.localQuery[this.field] ? moment(this.localQuery[this.field], 'YYYY-MM-DD') : moment().hour(0).minute(0).second(0)
      },
      fieldFormat() {
        return this.fieldDate.format(this.displayFormat)
      },
      ariaLabel() {
        return this.tc('accessibility.selectStayDate', {
          dateType: this.tc(`booking.${this.label}`)
        })
      }
    },
    watch: {
      isSelected(val) {
        if (val) {
          this.bindKeyboardEvents()
        } else {
          this.unbindKeyboardEvents()
        }
      }
    },
    mounted() {
      if (this.isSelected) {
        this.bindKeyboardEvents()
      }
    },
    methods: {
      addOneDay() {
        this.updateLocalQuery({ prop: this.field, value: this.fieldDate.add(1, 'day').format(this.updateFormat) })
      },
      removeOneDay() {
        this.updateLocalQuery({ prop: this.field, value: this.fieldDate.subtract(1, 'day').format(this.updateFormat) })
      },
      selectInput() {
        this.$emit('selected', this.field)
      },
      toggleInput() {
        const otherField = this.fields.filter((f) => f.field !== this.field)[0]
        const otherElement = document.getElementById(`${otherField.field}-calendar-scroll-field`)
        this.$emit('selected', otherField.field)
        if (otherElement) {
          otherElement.focus()
        }
      },
      bindKeyboardEvents() {
        if (this.isSelected) {
          this.$el.addEventListener('keydown', this.onKeydownEvent)
        }
      },
      unbindKeyboardEvents() {
        this.$el.removeEventListener('keydown', this.onKeydownEvent)
      },
      onKeydownEvent(e) {
        if (e.keyCode === KEY_CODE_MAP.ARROW_RIGHT || e.keyCode === KEY_CODE_MAP.ARROW_LEFT) {
          this.toggleInput()
        }
      }
    }
  }
</script>
